<div class="whatsapp-card-container">
  <button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="whatsapp-bubble">
    <!-- Media Section -->
    <div class="media-preview" [ngSwitch]="data.type" *ngIf="data.data">
      <!-- Image -->
      <img *ngSwitchCase="'image'" [src]="safeMediaUrl" (click)="close()" style="cursor: pointer;">
      
      <!-- Video -->
      <video *ngSwitchCase="'video'" [src]="safeMediaUrl" controls autoplay></video>
      
      <!-- Audio -->
      <div *ngSwitchCase="'audio'" class="audio-preview">
        <mat-icon>audiotrack</mat-icon>
        <audio [src]="safeMediaUrl" controls autoplay></audio>
      </div>
      
      <!-- Document -->
      <div *ngSwitchCase="'document'" class="doc-preview">
        <mat-icon>{{ getDocumentIcon(data.item?.mediaData?.extension) }}</mat-icon>
        <div class="doc-info">
          <span>View Document</span>
          <small>{{ data.item?.mediaData?.extension || 'PDF' }}</small>
        </div>
      </div>

      <!-- Fallback -->
      <img *ngSwitchDefault [src]="safeMediaUrl">
    </div>

    <!-- Content Section -->
    <div class="bubble-content">
      <!-- Caption / Body -->
      <div class="caption-text" *ngIf="caption">
        {{ caption }}
      </div>

      <!-- Interactive Buttons -->
      <div class="interactive-buttons" *ngIf="parsedData?.interactive?.buttons?.length || parsedData?.template?.buttons?.length">
        <ng-container *ngIf="parsedData?.interactive?.buttons?.length">
          <div class="btn-item" *ngFor="let btn of parsedData.interactive.buttons">
            {{ btn }}
          </div>
        </ng-container>
        <ng-container *ngIf="parsedData?.template?.buttons?.length">
          <div class="btn-item" *ngFor="let btn of parsedData.template.buttons">
            {{ btn }}
          </div>
        </ng-container>
      </div>

      <!-- List / Menu Data -->
      <div class="list-data" *ngIf="parsedData?.interactive?.listData?.buttonText">
        <div class="list-btn">
          <span>{{ parsedData.interactive.listData.buttonText }}</span>
          <mat-icon>expand_more</mat-icon>
        </div>

        <div class="list-sections" *ngIf="parsedData.interactive.listData.sections">
           <div *ngFor="let section of parsedData.interactive.listData.sections" class="section-item">
              <div class="section-title" *ngIf="section.title">{{ section.title }}</div>
              <div *ngFor="let row of section.rows" class="row-item">
                 <div class="row-title">{{ row.title }}</div>
                 <div class="row-desc" *ngIf="row.description">{{ row.description }}</div>
              </div>
           </div>
        </div>
      </div>

      <!-- Footer / Meta -->
      <div class="bubble-footer">
        <span class="time">{{ formatMessageTime(parsedData?.messagedAt) }}</span>
        <span class="status" *ngIf="!parsedData?.isIncoming">
          <span *ngIf="parsedData?.status === 'read'" class="read">✓✓</span>
          <span *ngIf="parsedData?.status !== 'read'">✓</span>
        </span>
      </div>
    </div>
  </div>
</div>
